import axios from 'axios';
import { API_BASE_URL, handleApiError } from './_apiBase';

export interface DeviceParam {
    key: string;
    name: string | null;
    unit: string | null;
}

export interface AlertEvent {
    id: number;
    triggered_at: string;
    is_recovery: boolean;
    value: number;
    property: string;
    rule_id: number;
    rule_name: string;
    deviation_token: string | null;
    reporter_name: string | null;
    reason: string | null;
    action_taken: string | null;
    submitted_at: string | null;
}

export interface MonthlyReportData {
    device: { id: number; name: string; ieee_address: string };
    parameter: { id: number; key: string; name: string | null; unit: string | null };
    year: number;
    month: number;
    /** 'downsampled' = 15-minutersvärden ur långtidslagringen (alert_property_readings). */
    readingsSource: 'detailed' | 'downsampled' | 'mixed';
    /** Tidpunkt (ms) där de nedsamplade värdena tar slut och de detaljerade tar vid. */
    downsampledUntil: number | null;
    readings: Array<{ ts: number; value: number | null; value_str: string | null }>;
    alertEvents: AlertEvent[];
}

export const fetchDeviceParamsForReport = async (ieee: string): Promise<DeviceParam[]> => {
    try {
        const res = await axios.get(`${API_BASE_URL}/reports/device-params`, { params: { ieee } });
        return res.data;
    } catch (error) { return handleApiError(error, 'Hämta enhetens parametrar') ?? []; }
};

export const fetchMonthlyReport = async (
    ieee: string,
    parameterKey: string,
    year: number,
    month: number,
): Promise<MonthlyReportData | null> => {
    try {
        const res = await axios.get(`${API_BASE_URL}/reports/monthly`, {
            params: { ieee, parameterKey, year, month },
            timeout: 30000,
        });
        return res.data;
    } catch (error) { return handleApiError(error, 'Hämta månadsrapport'); }
};
